module.exports = __webpack_public_path__ + "img/home-icon-active.4001f166.svg";